import { convertWorkLog } from "../../../services/workLog";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_INVOICES } from "../../payments/keys";
import { QUERY_WORK_LOGS } from "../queries/useQueryWorkLogs";

export const useMutationConvertWorkLogs = () =>
  useWSMutation<
    Awaited<ReturnType<typeof convertWorkLog>>,
    WSServiceError,
    {
      workLogId: string;
    }
  >(variables => convertWorkLog(variables.workLogId), {
    dependencies: [QUERY_WORK_LOGS, QUERY_INVOICES]
  });
